import Videos from './Videos.vue'

export default Videos
